import { Box, FlexColumn, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";
import css from "./CustomViewOptions.module.css";
import TableCustomViewOptionsStore from "./TableCustomViewOptionsStore";

const ChartOptions: FunctionComponent = observer((props) => {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		onChangeChartHeight,
		selectedChartHeight,
		setChartHideTable,
		tableDropDownOptions,
		tableOptions,
	} = optionsStore as TableCustomViewOptionsStore;

	const {
		chartHideTable,
	} = tableOptions;

	return (
		<>
			<Box className={css.container}>
				<FlexColumn 
					className={css.optionLeft}
					data-csi-automation="CustomViewTableChartHeight"
				>
					<SingleSelect
						disableClearable
						fullWidth
						labelRes="CustomViewTableChartHeight"
						onChange={onChangeChartHeight}
						options={tableDropDownOptions.chartHeights}
						value={selectedChartHeight}
					/>
				</FlexColumn>
			</Box>
			<CheckboxOption
				dataCsiAutomation="CustomViewTableChartHideTable"
				label="CustomViewTableChartHideTable"
				onChange={setChartHideTable}
				optionValue={chartHideTable}
				paddingLeft={0}
			/>
		</>
	);
});

export default ChartOptions;